import { render, staticRenderFns } from "./comment_child.vue?vue&type=template&id=4b0348fc&scoped=true"
import script from "./comment_child.vue?vue&type=script&lang=js"
export * from "./comment_child.vue?vue&type=script&lang=js"
import style0 from "./comment_child.vue?vue&type=style&index=0&id=4b0348fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0348fc",
  null
  
)

export default component.exports